import Hero from './components/Hero';
import CoreServices from './components/CoreServices';
import WhyFourLab from './components/WhyFourLab';
import ProjectsPreview from './components/ProjectsPreview';
import VoucherSection from './components/VoucherSection';
import CTA from './components/CTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <CoreServices />
      <WhyFourLab />
      <ProjectsPreview />
      <VoucherSection />
      <CTA />
    </div>
  );
}
